/* eslint-disable no-console */
/* eslint-disable no-unused-vars */
import React from 'react';
import Draggable from 'react-draggable';

const CustomDraggable = ({ children , classeName, defaultPosition = { x: -150, y: 50 } }) => {
  const handleStart = (e, ui) => {
    // Função de callback chamada quando o arraste é iniciado
  };

  const handleDrag = (e, ui) => {
    // Função de callback chamada durante o arraste
  };

  const handleStop = (e, ui) => {
    // Função de callback chamada quando o arraste é finalizado
  };

  return (
    <Draggable
      cancel={classeName}
      defaultPosition={defaultPosition}
      position={null}
      scale={1}
      onStart={handleStart}
      onDrag={handleDrag}
      onStop={handleStop}
      style={{ zIndex: 1700 }}
    >
      {children}
    </Draggable>
  );
};

export default CustomDraggable;
